import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import React, { useEffect, useState } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import nodeinstance from "../../../../nodeInstance";
import { CgSpinner } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";
import UploadFilePopUp_New from "../../../../ReusableComponents/UploadFile/UploadFileNew";

export default function FinListDataOnArrivalMedical({
  titles = [],
  list = [],
  token,
  updateList,
}) {
  //select Date
  const [searchWords, setSearchWords] = useState([]);
  const [editingIndex, setEditingIndex] = React.useState();
  const [inputValue, setInputValue] = React.useState("0");
  const [Popup, setPopUp] = useState(false);

  const dispatch = useDispatch();
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const apiCall = () => {
    updateList("");
  };

  //edit text Field
  const handleEdit = (index, initialValue) => {
    setEditingIndex(index);
    setInputValue(initialValue);
  };

  // list.border_number
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    console.log(event.target.value);
  };

  //download File Api

  const [downloadLoading, setDownloadLoading] = useState(false);
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/employees/downloadOnArrivalMedicalExcel?finance=1`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OnArrivalMedical`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const update = async (type) => {
    try {
      // employees/downloadBorderNumberExcel
      console.log(type);
      const res = await nodeinstance.post("/employees/updateActualFees", type, {
        headers: { Authorization: `Bearer ${token}` },
        // body: type
      });
      console.log(res);
      if (res.status == 200) {
        setEditingIndex(-1);
        apiCall();
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => setPopUp(true)}
          >
            <p>Upload List</p>
            {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
          </button>
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => downloadFile()}
            disabled={downloadLoading || list?.isLoading}
          >
            <p>Download</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>
          <Search
            searchKey={[
              "employee_id",
              "visa_provider",
              "Client_Name",
              "name",
              "visa_block_number",
              "border_number",
              "passport_number"
            ]}
            setSearchWords={setSearchWords}
          />
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[2500px]">
              <div className="grid grid-cols-table-finOnArrivalMedical gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-finOnArrivalMedical gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {!list?.isLoading && <NoDataFound />}
              {!list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.Client_Name || "-"}
                      />
                    </p>

                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.sponsor_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_reference_number || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_stamping_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_block_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.border_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.passport_number || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.medical_application_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.medical_status || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.medical_status_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.medical_dependency || "-"}
                      />
                    </p>

                    <p>
                      {editingIndex === index ? (
                        <input
                          defaultValue={
                            list.medical_dependency === "LOCAL TRANSFER"
                              ? 0
                              : list.actual_fees_paid ||
                                  list.medical_dependency === "CLIENT"
                                ? 0
                                : list.actual_fees_paid
                          }
                          step={"0.01"}
                          pattern="[0-9]*"
                          min={10}
                          type="text"
                          name={list.actual_fees_paid}
                          className={`input input-sm h-10 max-w-xs  w-full 
                    input-bordered focus:outline-none uppercase`}
                          id={list.actual_fees_paid}
                          required="er"
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                          // onChange={}
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.actual_fees_paid || "-"}
                          />
                        </p>
                      )}
                    </p>
                    <button
                      className={
                        editingIndex === index
                          ? "px-2 rounded-md  bg-green-500 text-white text-xs p-2 w-20"
                          : "px-2 rounded-md  bg-red text-white text-xs p-2 w-20"
                      }
                      onClick={() => {
                        if (editingIndex === index) {
                          update({
                            employeeId: list.employee_id,
                            actual_fees_paid: inputValue,
                          });
                        } else {
                          handleEdit(index, list.medical_status_date);
                          setInputValue(
                            list.actual_fees_paid === null ||
                              list.actual_fees_paid === ""
                              ? "0"
                              : list.actual_fees_paid
                          );
                        }
                      }}
                    >
                      {editingIndex === index ? "Save" : "Update"}
                    </button>
                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
        <Pagination />
        {/* <CountPerPage />
        <div
          className={`grid grid-cols-table- auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {!list?.isLoading && <NoDataFound />}

          {!list?.isLoading
            ? currentList?.map((list, index) => (
                
              ))
            : ""}
        </div>
        <Pagination /> */}
      </div>
      {Popup ? (
        <UploadFilePopUp_New
          PopUp={Popup}
          callBack={apiCall}
          setPopUp={setPopUp}
          title={"Upload ON ARRIVAL MEDICAL"}
          url={"/employees/updateMedicalInfoFromExcel?finance=1"}
        />
      ) : (
        ""
      )}
    </>
  );
}
